<div class="notification-overlay" *ngIf="isOpen$ | async" (click)="close()">
  <div class="notification-panel" (click)="$event.stopPropagation()">
    <header class="panel-header">
      <h2>Notifications</h2>
      <button class="close-btn" (click)="close()">
        <img src="assets/icons/close.svg" alt="Close" />
      </button>
    </header>

    <div class="notification-list">
      <div *ngFor="let notification of notifications$ | async" 
           class="notification-item" 
           [class.unread]="!notification.isRead">
        
        <div class="notification-avatar" [style.background]="notification.avatar ? getAvatarBackground(notification.avatar) : ''">
          <span *ngIf="notification.avatar">{{ notification.avatar }}</span>
          <img *ngIf="notification.icon" [src]="notification.icon" alt="icon" />
        </div>

        <div class="notification-content">
          <div class="notification-top">
            <span class="notification-title">{{ notification.title }}</span>
            <div class="notification-meta">
              <span class="timestamp">{{ notification.timestamp }}</span>
              <div class="status-dot" *ngIf="!notification.isRead"></div>
              <button class="more-btn">
                <img src="assets/icons/more-vertical.svg" alt="More" />
              </button>
            </div>
          </div>
          <p class="notification-subtitle">{{ notification.subtitle }}</p>
          <div class="notification-amount" *ngIf="notification.amount" 
               [class.positive]="notification.amount.startsWith('+')"
               [class.negative]="notification.amount.startsWith('-')">
            {{ notification.amount }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
